<template>
    <ConfirmDialog :draggable="false" :visible="visible" group="headless">
        <template #container="{ message, acceptCallback, rejectCallback }">
            <div class="flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded">
                <span class="p-dialog-title w-full mb-6">{{ message.header }}</span>

                <FormItem itemLabel="" class="w-full">
                    <template v-slot:content>
                        <InputText
                            class="w-full"
                            autocomplete="off"
                            v-model="input"
                            :class="{ 'p-invalid': isEmpty }"
                            autofocus
                            @keyup.enter="acceptCallback"
                        />
                    </template>
                </FormItem>

                <div class="flex w-100 justify-end gap-2 mt-6">
                    <Button label="Cancel" outlined @click="rejectCallback"></Button>
                    <Button
                        :label="okLabel"
                        @click="acceptCallback"
                        :disabled="input == ''"
                        :loading="loading"
                    ></Button>
                </div>
            </div>
        </template>
    </ConfirmDialog>
</template>

<script setup>
import ConfirmDialog from "primevue/confirmdialog";
import { ref, defineProps, defineEmits, onMounted } from "vue";
import { useConfirm } from "primevue/useconfirm";
import { Button, InputText } from "primevue";
import FormItem from "../components/FormItem.vue";

const emit = defineEmits(["update:visible", "onCreation"]);
const confirm = useConfirm();
const visible = ref(false);
const input = ref("");

const props = defineProps({
    saveAction: {
        type: Function,
    },
    okLabel: {
        type: String,
    },
    loading: {
        type: Boolean,
        default: false,
    },
    visible: {
        type: Boolean,
    },
    title: {
        type: String,
        default: " ",
    },
});

onMounted(() => {
    requireConfirmation();
});

const requireConfirmation = () => {
    visible.value = true;
    confirm.require({
        group: "headless",
        header: props.title,
        message: "Please confirm to proceed.",
        accept: async () => {
            try {
                if (input.value == "" || !input.value) {
                    return;
                }

                await props.saveAction(input.value);
                close();
            } catch (error) {}
        },
        reject: () => {
            close();
        },
        onHide: () => {
            close();
        },
    });
};

const close = () => {
    emit("update:visible", false);
    visible.value = false;
};
</script>

<style scoped></style>
